module.exports = __webpack_public_path__ + "img/mingle.d1cf687.png";